import React from 'react'
export const DASHBOARD_HEADER = [
  {
    label: "Application ID",
    title: "Application ID",
    key: "applId",
  },
  {
    label: "Application Received Date",
    title: "Application Received Date",
    key: "applReceivedDate",
  },

  {
    label: "Application Status",
    title: "Application Status",
    key: "applStatus",
  },
  {
    label: "First Name",
    title: "First Name",
    key: "firstName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },
  {
    label: "Last Saved",
    title: "Last Saved",
    key: "lastSaved",
  },
  {
    label: "Agent Name",
    title: "Agent Name",
    key: "createdBy",
  },
  {
    label: "Last Updated By",
    title: "Last Updated By",
    key: "updatedBy",
  },
];
export const DASHBOARD_HEADER1 = [
  {
    label: "Application ID",
    title: "Application ID",
    key: "applId",
  },
  {
    label: "Application Received Date",
    title: "Application Received Date",
    key: "applReceivedDate",
  },

  {
    label: "Application Status",
    title: "Application Status",
    key: "applStatus",
  },
  {
    label: "First Name",
    title: "First Name",
    key: "firstName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },
  {
    label: "Last Saved",
    title: "Last Saved",
    key: "lastSaved",
  },
  {
    label: "Agent Name",
    title: "Agent Name",
    key: "createdBy",
  }
];
export const CALLS_HEADER = [
  {
    label: "First Name",
    title: "First Name",
    key: "contactName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },

  {
    label: "Relationship",
    title: "Relationship",
    key: "relation",
  },
  {
    label: "Date of Call",
    title: "Date of Call",
    key: "dateOfCall",
  },
  {
    label: "Comment Date",
    title: "Comment Date",
    key: "commentDate",
  },
  {
    label: "User ID",
    title: "User ID",
    key: "user",
  },
];

export const CALLS_COMMENT_HEADER = [
  {
    label: "Comment",
    title: "Comment",
    key: "comment",
  },
  {
    label: "User",
    title: "User",
    key: "user",
  },
  {
    label: "Created",
    title: "Created",
    key: "createDate",
  },
];

export const PROSPECT_TABLE_HEADER = [
  {
    label: "Lead ID number",
    title: "Lead ID number",
    key: "leadIdNbr",
  },
  {
    label: "First Name",
    title: "First Name",
    key: "firstName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },
  {
    label: "Plan Campaign Name",
    title: "Plan Campaign Name",
    //key: "planCampaignName",
    key:"planCampaignId"
  },
  {
    label: "Phone Number",
    title: "Phone Number",
    key: "phoneNumber",
  },
  {
    label: "Assigned to",
    title: "Assigned to",
    key: "assignedTo",
  },
  {
    label: "Status",
    title: "Status",
    key: "statusType",
  },
  {
    label: "Last updated by",
    title: "Last updated by",
    key: "updatedBy",
  },
  {
    label:"Created Date",
    title:"Created Date",
    key:"createdTime"
  },
  {
    label: "SOA",
    title: "SOA",
    key: "SOA",
  },
  {
    label: "Enroll",
    title: "Enroll",
    key: "Enroll",
  },
];

export const CAMPAIGN_TABLE_HEADER = [
  {
    title: "e-Enroll Campaign ID",
    label: "e-Enroll Campaign ID",
    key: "enrlCampaignId",
  },
  {
    title: "Plan Campaign ID",
    label: "Plan Campaign ID",
    key: "planCampaignId",
  },
  {
    label: "Plan Campaign Name",
    title: "Plan Campaign Name",
    key: "planCampaignName",
  },
  { label: "Start Date", title: "Start Date", key: "startDate" },
  { label: "End Date", title: "End Date", key: "endDate" },
  {
    label: "Campaign Owner",
    title: "Cmpaign Owner",
    key: "campaignOwner",
  },
  { label: "Status", title: "Status", key: "status" },
  { label: "Last Update", title: "Last Update", key: "lastUpdate" },
];
export const KEY_PERFORMANCE_BY_AGENT=[
    {label:"Customer ID",key:"custId"},
    { label: "Agent Email", key: "agentMail" },
    { label: "Agent Name", key: "agentName" },
    { label: "Application ID", key: "appId" },
    { label: "Beneficiary Name", key: "beneName" },
    { label: "Plan Name", key: "planName" },
    { label: "MBI", key: "mediCareId" },
    { label: "Status", key: "status" },
]
export const KEY_PERFORMANCE_BY_CAMPAIGN=[
  { label: "Campaign Id", key: "campaignId" },
  { label: "Campaign Name", key: "campaignName" },
  { label: "Beneficiary Name", key: "beneName" },
  { label: "Beneficiary Address", key: "beneAddress" },
]
export const VERDA_DASHBOARD_HEADER_PDF1 = [
  {
    label: "Application ID",
    title: "Application ID",
    key: "applId",
  },
  {
    label: "Application Received Date",
    title: "Application Received Date",
    key: "applReceivedDate",
  },
  {
    label: "Application Status",
    title: "Application Status",
    key: "applStatus",
  },
  {
    label: "First Name",
    title: "First Name",
    key: "firstName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },
  {
    label: "Submitted Date",
    title: "Submitted Date",
    key: "lastSaved",
  },
  {
    label: "Agent Name",
    title: "Agent Name",
    key: "createdBy",
  },
  {
    label: "SOA PDF",
    title: "SOA PDF",
    key: "DOWNLOADSOA",
  },
  {
    label: "Application PDF",
    title: "Application PDF",
    key: "DOWNLOAD",
  },
  {
    label: "PRE-ENROLLMENT FORM",
    title: "PRE-ENROLLMENT FORM",
    key: "PREENROLLMENTFORM",
  },
  {
    label: "COORDINATION OF CARE",
    title:"COORDINATION OF CARE",
    key:"COORDINATIONOFCARE",
  }
];
export const VERDA_DASHBOARD_HEADER_PDF = [
  {
    label: "Application ID",
    title: "Application ID",
    key: "applId",
  },
  {
    label: "Application Received Date",
    title: "Application Received Date",
    key: "applReceivedDate",
  },
  {
    label: "Application Status",
    title: "Application Status",
    key: "applStatus",
  },
  {
    label: "First Name",
    title: "First Name",
    key: "firstName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },
  {
    label: "Submitted Date",
    title: "Submitted Date",
    key: "lastSaved",
  },
  {
    label: "Agent Name",
    title: "Agent Name",
    key: "createdBy",
  },
  {
    label: "Last Updated By",
    title: "Last Updated By",
    key: "updatedBy",
  },
  {
    label: "SOA PDF",
    title: "SOA PDF",
    key: "DOWNLOADSOA",
  },
  {
    label: "Application PDF",
    title: "Application PDF",
    key: "DOWNLOAD",
  },
  {
    label: "PRE-ENROLLMENT FORM",
    title: "PRE-ENROLLMENT FORM",
    key: "PREENROLLMENTFORM",
  },
  {
    label: "COORDINATION OF CARE",
    title:"COORDINATION OF CARE",
    key:"COORDINATIONOFCARE",
  }
];
export const DASHBOARD_HEADER_PDF = [
  {
    label: "Application ID",
    title: "Application ID",
    key: "applId",
  },
  {
    label: "Application Received Date",
    title: "Application Received Date",
    key: "applReceivedDate",
  },
  {
    label: "Application Status",
    title: "Application Status",
    key: "applStatus",
  },
  {
    label: "First Name",
    title: "First Name",
    key: "firstName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },
  {
    label: "Submitted Date",
    title: "Submitted Date",
    key: "lastSaved",
  },
  {
    label: "Agent Name",
    title: "Agent Name",
    key: "createdBy",
  },
  {
    label: "Last Updated By",
    title: "Last Updated By",
    key: "updatedBy",
  },
  {
    label: "SOA PDF",
    title: "SOA PDF",
    key: "DOWNLOADSOA",
  },
  {
    label: "Application PDF",
    title: "Application PDF",
    key: "DOWNLOAD",
  }
];
export const DASHBOARD_HEADER_PDF1 = [
  {
    label: "Application ID",
    title: "Application ID",
    key: "applId",
  },
  {
    label: "Application Received Date",
    title: "Application Received Date",
    key: "applReceivedDate",
  },
  {
    label: "Application Status",
    title: "Application Status",
    key: "applStatus",
  },
  {
    label: "First Name",
    title: "First Name",
    key: "firstName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },
  {
    label: "Submitted Date",
    title: "Submitted Date",
    key: "lastSaved",
  },
  {
    label: "Agent Name",
    title: "Agent Name",
    key: "createdBy",
  },
  
  {
    label: "SOA PDF",
    title: "SOA PDF",
    key: "DOWNLOADSOA",
  },
  {
    label: "Application PDF",
    title: "Application PDF",
    key: "DOWNLOAD",
  }
];
export const ProspectModalBulkHeader = [
  
    {
      label: "First Name",
      title: "First Name",
      key: "firstName"
    },
    {
      label: "Last Name",
      title: "Last Name",
      key: "lastName"
    },
    {
      label: "MBI",
      title: "MBI",
      key: "mbiNumber"
    },
    {
      label: "DOB",
      title: "DOB",
      key: "birthDate"
    },
    // {
    //   label: "Gender",
    //   title: "Gender",
    //   key: "sex"
    // },
    // {
    //   label: "Eligible for Part A",
    //   title: "Eligible for Part A",
    //   key: "eligibleForPartA"
    // },
    // {
    //   label: "Eligible for Part B",
    //   title: "Eligible for Part B",
    //   key: "eligibleForPartB"
    // },
    // {
    //   label: "Eligible for Part D",
    //   title: "Eligible for Part D",
    //   key: "eligibleForPartD"
    // },
    // {
    //   label: "Permission To Contact",
    //   title: "Permission To Contact",
    //   key: "permissionToContact"
    // },
    // {
    //   label: "Preferred Language",
    //   title: "Preferred Language",
    //   key: "preferredLang"
    // },
    // {
    //   label: "Plan Type",
    //   title: "Plan Type",
    //   key: "planType"
    // },
    // {
    //   label: "Status Type",
    //   title: "Status Type",
    //   key: "statusType"
    // }
   {
     label:"Primary Address1",
     title:"Primary Address1",
     key:"primaryAddress1",
   },
   {
    label:"Zip",
    title:"Zip",
    key:"zipCode",
  }
  ]
export const CampaignModalBulkHeader=[
  // {label:"Upload Detail Id",
  // title:"uploadDetailId",
  // key:"uploadDetailId"
  // },
  {
    label: "Campaign Name",
    title: "Campaign Name",
    key: "planCampaignName"
  },
  {
    label: "Plan Campaign ID",
    title: "Plan Campaign ID",
    key: "planCampaignId"
  },
  // {
  //   label: "Campaign Owner",
  //   title: "Campaign Owner",
  //   key: "CampaignOwner"
  // },
  // {
  //   label: "Associated Product",
  //   title: "Associated Product",
  //   key: "AssociatedProduct"
  // },
  // {
  //   label: "Campaign Media",
  //   title: "Campaign Media",
  //   key: "CampaignMedia"
  // },
  {
    label: "Status",
    title: "Status",
    key: "campaignStatus"
  },
  {
    label: "Start Date",
    title: "Start Date",
    key: "campaignStartDate"
  },
  {
    label: "End Date",
    title: "End Date",
    key: "campaignEndDate"
  },
]  
export const BulkHeader = [
 
    
    {
      label: "File Name",
      title: "File Name",
      key: "uploadFileName"
    },
    {
      label: "Date",
      title: "Date",
      key: "uploadDate"
    },
    {
      label: "User ID",
      title: "User ID",
      key: "uploadedBy"
    },
    {
      label: "Status",
      title: "Status",
      key: "uploadStatus"
    },
    {
      label: "#Loaded",
      title: "#Loaded",
      key: "totalCount"
    },
    {
      label: "#Success",
      title: "#Success",
      key: "successCount"
    },
    {
      label: "#Rejected",
      title: "#Rejected",
      key: "rejectionCount"
    },
    {
      label: "#Errored",
      title: "#Errored",
      key: "errorCount"
    }
  ]
export const EVENTS_POPUP_HEADER = [
 
  {
    label: "First Name",
    title: "First Name",
    key: "firstName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },
  {
    label: "Plan Campaign Name",
    title: "Plan Campaign Name",
    //key: "planCampaignName",
    key:"planCampaignId"
  },
  {
    label: "Phone Number",
    title: "Phone Number",
    key: "phoneNumber",
  },
  {
    label: "Others",
    title: "Others",
    key: "Others",
  },
];
export const DOCUMENT_HEADER = [
  {
    label: "Document Type",
    title: "Document Type",
    key: "documentType",
  },
  {
    label: "Document name",
    title: "Document name",
    key: "documentName",
  },

  {
    label: "Uploaded document ",
    title: "Uploaded document ",
    key: "uploadedDocument",
  },
  {
    label: "Uploaded by ",
    title: "Uploaded by ",
    key: "uploadedBy",
  },
  {
    label: "Uploaded date",
    title: "Uploaded date",
    key: "uploadeDate",
  },
  {
    label: "",
    title: "",
    key: "deleteRow",
  }
];
export const APPOPINTMENT_TABLE_HEADER = [
  {
    title: "Appointment Date",
    label: "Appointment Date",
    key: "appointmentDate",
  },
  {
    title: "Start Time",
    label: "Start Time",
    key: "startTime",
  },
  {
    label: "End Time",
    title: "End Time",
    key: "endTime",
  },
  { label: "Agent", title: "Agent", key: "agentName" },
  { label: "SOA Completed", title: "SOA Completed", key: "soaInd" },
  {
    label: "Notes",
    title: "Notes",
    key: "note",
  },
];

export const USER_DATA_HEADER = [
  {
    label: "First Name",
    title: "First Name",
    key: "firstName",
  },
  {
    label: "Last Name",
    title: "Last Name",
    key: "lastName",
  },

  {
    label: "Agent ID",
    title: "Agent ID",
    key: "agentId",
  },
  {
    label: "Agency ID",
    title: "Agency ID",
    key: "agencyId",
  },
  {
    label: "Role",
    title: "Role",
    key: "roleDesc",
  },
  {
    label: "User ID",
    title: "User ID",
    key: "userId",
  },
  {
    label: "Email ID",
    title: "Email ID",
    key: "emailId",
  }
];